import React, { useState } from "react";
import { Delete } from "../../HemeIconLibrary";
import Modal from "react-bootstrap/Modal";
const DeleteButton = ({ data, cta, key }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="flex-shrink-0 cursor-pointer">
      <p
        className="m-0"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <Delete color="#605DAF" />
      </p>

      <Modal key={key} size="md" aria-labelledby="contained-modal-title-vcenter" centered show={showModal} onHide={() => setShowModal(false)} animation={false}>
        <Modal.Body>
          <p className="text-base font-semibold m-0 text-center">Are you sure, you want to Remove?</p>
        </Modal.Body>

        <Modal.Footer>
          <div className="flex gap-[20px]  items-center justify-center w-full">
            <p
              className="user-down-item text-base font-semibold cursor-pointer m-0"
              onClick={() => {
                if (cta) {
                  cta(data, false);
                  setShowModal(false);
                }
              }}
            >
              Yes
            </p>
            <p className="user-down-item text-base font-semibold cursor-pointer m-0" onClick={() => setShowModal(false)}>
              No
            </p>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeleteButton;
